import { render } from "./Contact.vue?vue&type=template&id=413c3eb2&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=413c3eb2&lang=scss&scoped=true"

import exportComponent from "/home/marko/Documents/Projects/praksa/petikom-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-413c3eb2"]])

export default __exports__